export default __webpack_public_path__ + "static/media/checkout.52dbbb03.jpg";